import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const PostularBarContainer = styled('div')`
  width: 100%;
  background: white;
  padding: 10px 16px 16px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    padding: 10px 28px 16px;
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    padding: 16px;
    border-radius: 8px;
    top: 80px;
  }
`

export const WordingContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const PostuladoText = styled('h1')`
  font-weight: 600;
  font-size: 22px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.secondary.normal};

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    font-size: 24px;
  }
`

export const IconCustom = styled(Icon)`
  ${({ marginRight }) => marginRight && `margin-right: ${marginRight}`}
`
